import { render, staticRenderFns } from "./explain-kpi-metrics.component.vue?vue&type=template&id=948a643e&scoped=true"
import script from "./explain-kpi-metrics.component.vue?vue&type=script&lang=ts"
export * from "./explain-kpi-metrics.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-kpi-metrics.component.vue?vue&type=style&index=0&id=948a643e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948a643e",
  null
  
)

export default component.exports